<template>
  <div
    v-if="loading"
    class="dropdown nodro item">
    <i class="fas fa-spinner spin"/>
  </div>
  <BaseActionDropdown
    v-else-if="processStatus === DOCUMENT_RPOCESS_STATUS.PENDING"
    :className="`text-warning`"
    :icon="`far fa-circle`"
    :text="$t(`status.${docType}.pending`)"
    :items="statusOptions"
    @onSelect="handleSelect"
  />
  <div
    v-else
    class="dropdown nodro item">
    <BaseDocumentProcessStatus
      :docType="docType"
      :status="processStatus"
    />
  </div>
</template>

<script>
import { DOCUMENT_STATUS, DOCUMENT_RPOCESS_STATUS } from '@/helpers/enum'

export default {
  props: {
    docType: String,
    loading: Boolean,
    processStatus: String,
  },

  data () {
    return {
      DOCUMENT_RPOCESS_STATUS,
    }
  },

  computed: {
    statusOptions () {
      return [
        {
          icon: 'far fa-check-circle',
          iconClassName: 'text-info',
          iconStyle: { position: 'relative', left: '-7px' },
          text: this.$t(`status.${this.docType}.approve`),
          textClassName: 'text-info',
          value: DOCUMENT_STATUS.APPROVED,
        },
        {
          icon: 'far fa-times-circle',
          iconClassName: 'text-danger',
          iconStyle: { position: 'relative', left: '-7px' },
          text: this.$t(`status.${this.docType}.reject`),
          textClassName: 'text-danger',
          value: DOCUMENT_STATUS.REJECTED,
        },
      ]
    },
  },

  methods: {
    handleSelect (value) {
      this.$emit('onSelect', value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseActionUpdateStatus.vue